import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import Gen2 from './Gen2';
import Product from './Product';
import Merge from './Merge';
import Login from './Login';
import UserManagement from './UserManagement';
import AdminLayout from './AdminLayout';
import axios from './auth';
import './index.css';

// 路由守卫组件
function RequireAuth({ children }) {
  const [verified, setVerified] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setVerified(false);
      return;
    }

    // 验证 token 有效性
    axios.get('/api/auth/verify')
      .then(res => {
        if (res.data.success) {
          setVerified(true);
        } else {
          setVerified(false);
        }
      })
      .catch(() => setVerified(false));
  }, []);

  if (verified === null) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f2f5'
      }}>
        <div>加载中...</div>
      </div>
    );
  }

  if (!verified) {
    return <Navigate to="/login" replace />;
  }

  return <AdminLayout>{children}</AdminLayout>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <RequireAuth>
            <App />
          </RequireAuth>
        } />
        <Route path="/gen2" element={
          <RequireAuth>
            <Gen2 />
          </RequireAuth>
        } />
        <Route path="/product" element={
          <RequireAuth>
            <Product />
          </RequireAuth>
        } />
        <Route path="/merge" element={
          <RequireAuth>
            <Merge />
          </RequireAuth>
        } />
        <Route path="/users" element={
          <RequireAuth>
            <UserManagement />
          </RequireAuth>
        } />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
